import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const CreativesApproval = {
  CreativesApprovalList: lazyNamed(() => import('./containers/CreativesApprovalList/index.tsx'), 'CreativesApprovalList'),
};
